"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _link = require("./link");

var trackParentCategory = function trackParentCategory(title, url) {
  return {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    click_source: 'menu',
    category_type: 'parent category'
  };
};

var gaEvents = function gaEvents(url) {
  return {
    eventCategory: 'Homepage',
    eventAction: 'Menu clicked',
    eventLabel: {
      Link: url
    }
  };
};

var trackCategory = function trackCategory(title, url) {
  return {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    click_source: 'menu',
    category_type: 'category'
  };
};

var _default = function _default(_ref) {
  var title = _ref.title,
      url = _ref.url,
      _ref$categories = _ref.categories,
      categories = _ref$categories === void 0 ? [] : _ref$categories;
  return (0, _preact.h)("li", null, (0, _preact.h)(_link.CategoryLink, {
    track: trackParentCategory(title, url),
    gaEvents: gaEvents(url),
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    title: title
  }, (0, _preact.h)("strong", null, title)), categories.map(function (category) {
    return (0, _preact.h)(_link.CategoryLink, {
      href: (0, _absoluteUrlRuntime.resolveUrl)(category.url),
      key: category.id,
      track: trackCategory(category.title, category.url),
      gaEvents: gaEvents(category.url),
      title: category.title,
      topicsCount: category.topicCount
    }, category.title);
  }));
};

exports.default = _default;